/* Yerb homepage reveal: jeden IO, guard, editor-safe.
   Skryvani obsahu je v CSS gatovane tridou html.yh-anim, kterou pridava
   az tento skript - kdyz se nenacte (blokace, no-JS), obsah je videt. */
(function () {
  if (window.__yhReveal) return;
  window.__yhReveal = true;
  if (!('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('yh-anim');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (x) {
      if (x.isIntersecting) {
        x.target.classList.add('yh-in');
        io.unobserve(x.target);
      }
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });

  function init(scope) {
    (scope || document).querySelectorAll('.yh-reveal:not(.yh-in)').forEach(function (e) { io.observe(e); });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('.yh-reveal').forEach(function (el) { io.unobserve(el); });
  });
})();
